import { render, staticRenderFns } from "./InternalError.vue?vue&type=template&id=54e71c3e&scoped=true&"
var script = {}
import style0 from "./InternalError.vue?vue&type=style&index=0&id=54e71c3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e71c3e",
  null
  
)

export default component.exports